'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = backMiddleware;

var _session = require('redux/modules/session');

var _lockscreen = require('redux/modules/lockscreen');

var _trip = require('redux/modules/trip');

var _search = require('redux/modules/search');

var _actions = require('redux/modules/booking/actions');

var _gallery = require('redux/modules/gallery');

// import { replace } from 'react-router-redux';

function backMiddleware(_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;

  return function (next) {
    return function (action) {
      if (action.type === '@@router/LOCATION_CHANGE' && action.payload && action.payload.action && action.payload.action === 'POP') {
        if (getState().routing && getState().routing.locationBeforeTransitions && getState().routing.locationBeforeTransitions.pathname && getState().routing.locationBeforeTransitions.pathname.match(/^\/booking\/[0-9a-f]+\/success\/?(\?.*)?$/i) && window && window.location) {
          window.location = '/';
        }
        if (getState().session.openMobileNav) {
          dispatch((0, _lockscreen.removeId)('mobile-nav'));
          return dispatch((0, _session.openMobileNav)(false));
        }
        if (getState().session.openMobileQuickSearch) {
          return dispatch((0, _session.openMobileQuickSearch)(false));
        }
        if (getState().search.mobileFilter) {
          return dispatch((0, _search.openMobileFilter)(false));
        }
        if (getState().search.openTourType) {
          return dispatch((0, _search.openTourType)(false));
        }
        if (getState().trip.openBook) {
          dispatch((0, _lockscreen.removeId)('mobile-trip-request'));
          return dispatch((0, _trip.openBook)(false));
        }
        if (getState().trip.openChat) {
          dispatch((0, _lockscreen.removeId)('trip-chat'));
          return dispatch((0, _trip.openChat)(false));
        }
        if (getState().trip.openShare) {
          dispatch((0, _lockscreen.removeId)('trip-share'));
          return dispatch((0, _trip.openShare)(false));
        }
        if (getState().booking.openDetail) {
          dispatch((0, _lockscreen.removeId)('booking-action'));
          return dispatch((0, _actions.openDetail)(false));
        }
        if (getState().gallery.isOpen) {
          dispatch((0, _lockscreen.removeId)('gallery'));
          return dispatch((0, _gallery.openGallery)(false));
        }
        // if (getState().booking.quickLX.step === 'home') {
        //   return dispatch(changeStep('initial'));
        // }
        // if (getState().booking.quickLX.step === 'yes') {
        //   return dispatch(changeStep());
        // }
        if (getState().booking.quickLX.step === 'home-newdate' || getState().booking.quickLX.step === 'no') {
          return dispatch((0, _actions.changeStep)('home'));
        }
        if (getState().booking.quickLX.step === 'no-1' || getState().booking.quickLX.step === 'no-2') {
          return dispatch((0, _actions.changeStep)('no'));
        }
        if (getState().booking.quickLX.step === 'no-1-newdate') {
          return dispatch((0, _actions.changeStep)('no-1'));
        }
        if (getState().booking.quickLX.step === 'no-2-newdate') {
          return dispatch((0, _actions.changeStep)('no-2'));
        }
        // if (getState().routing.locationBeforeTransitions) {
        //   if (getState().routing.locationBeforeTransitions.pathname.startsWith('/booking')) {
        //     const step = getState().routing.locationBeforeTransitions.query.step;
        //     if (step && step !== '4') {
        //       const id = getState().routing.locationBeforeTransitions.pathname.split('/')[2];
        //       let baseUrl = getState().routing.locationBeforeTransitions.pathname;
        //       if (id === 'new') {
        //         if (step === '3') {
        //           baseUrl += '?step=2';
        //         }
        //       }
        //       return dispatch(replace(baseUrl));
        //     }
        //   }
        // }
      } else if (action.payload && action.payload.action && action.payload.action === 'PUSH') {
        var currentPath = getState().routing.locationBeforeTransitions.pathname;
        var nextPath = action.payload.pathname;
        if ((!currentPath.startsWith('/to/') || !nextPath.startsWith('/trip/')) && getState().search.lastTripId) {
          setTimeout(function () {
            return dispatch((0, _search.setLastTripId)());
          }, 1000);
          // // dispatch(setLastTripId());
          // console.log('GG');
          // console.log('LAST: ', getState().search.lastTripId);
        }
      }
      // console.log('B After ', action);
      return next(action);
    };
  };
}
// import { openMobileFilter, openTourType } from 'redux/modules/search';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/backMiddleware.js
// module id = 1699
// module chunks = 47